import React from 'react';
import { getVariantSummary } from 'base/utils/product';
import { IAddCartInstance } from '@base/product/useAddCart';
import ThemePrice from '@base/lib/ThemePrice';
import { useTrans } from 'base/utils/i18n';

type ProdSummaryProps = {
    addCart: IAddCartInstance;
    className: string;
}

const ProdSummary: React.FC<ProdSummaryProps> = ({ addCart, className }) => {
    const { shownVariant, checkedAddOns, qty } = addCart;
    const summary = getVariantSummary(shownVariant, checkedAddOns, qty);
    const { t } = useTrans();

    return summary.retailPrice ? (
        <div tabIndex={0} className={className}>
            <ThemePrice
                value={summary.totalPrice}
                label={`${t('web_summary_total')}: `}
                className="total-price text-danger"
                forceDisplay
            />
            <ThemePrice
                isDel
                value={summary.retailPrice}
                label={`${t('web_summary_retail_price')}: `}
                className="del-price text-light"
                forceDisplay
            />
        </div>
    ) : (
        <div tabIndex={0} className={className}>
            <ThemePrice
                value={summary.totalPrice}
                label={`${t('web_summary_total')}: `}
                className="total-price"
                forceDisplay
            />
        </div>
    )
};

export default ProdSummary;
